import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const List = () => import('@/views/lesson-plan/List.vue')
const About = () => import('@/views/lesson-plan/About.vue')

const ListTopic = () => import('@/views/lesson-plan/ListTopic.vue')

const Detail = () => import('@/views/lesson-plan/Detail.vue')
const Mine = () => import('@/views/lesson-plan/Mine.vue')
const Edit = () => import('@/views/lesson-plan/Edit.vue')

const DisquisitionFeedBack = () => import('@/views/lesson-plan/FeedBack.vue')

const listRoute: RouteConfig = {
  path: '/lesson-plan-list',
  name: 'lesson_plan_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '教案课件',
    keepAlive: true,
    ignoreLogin: true,
  },
}

const aboutRoute: RouteConfig = {
  path: '/lesson-plan-about-page',
  name: 'lesson_plan_about_page',
  component: About,
  meta: {
    title: '功能描述',
  },
}

const listTopicRoute: RouteConfig = {
  path: '/lesson-plan-topic-list',
  name: 'lesson_plan_topic_list',
  component: ListTopic,
  props: (route) => ({ id: route.query.id }),

  meta: {
    title: '专题详情页',
    ignoreLogin: true,
  },
}
export const detailRoute: RouteConfig = {
  path: '/lesson-plan-detail',
  name: 'lesson_plan_detail',
  component: Detail,
  props: (route) => ({ ...route.query, ...route.params, id: route.query.id, qd: route.query.qd }),
  meta: {
    title: '教案详情',
    [GlobalConfigRouteMetaEnum.All]: true,
    ignoreLogin: true,
  },
}

export const mineRoute: RouteConfig = {
  path: '/lesson-plan-mine',
  name: 'lesson_plan_mine',
  component: Mine,
  meta: {
    title: '我的教案',
  },
}

export const editRoute: RouteConfig = {
  path: '/lesson-plan-edit',
  name: 'lesson_plan_edit',
  component: Edit,
  meta: {
    title: '教案上传',
  },
}

export const feedBackRoute: RouteConfig = {
  path: '/lesson-plan-feedback',
  name: 'lesson_plan_feedback',
  props: (route) => ({ ...route.query, ...route.params }),
  component: DisquisitionFeedBack,
  meta: {
    title: '专题意见征集',
  },
}

export default [listRoute, aboutRoute, listTopicRoute, detailRoute, mineRoute, editRoute, feedBackRoute]

export function navigateToLessonPlanList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToLessonPlanAbout(router: VueRouter) {
  router.push({ name: aboutRoute.name })
}

export function navigateToLessonPlanDetail(router: VueRouter, id: string, from: string) {
  router.push({ name: detailRoute.name, query: { id: id, from } })
}

export function navigateToLessonPlanMine(router: VueRouter) {
  router.push({ name: mineRoute.name })
}

export function navigateToLessonPlanEdit(router: VueRouter, p: any) {
  router.push({ name: editRoute.name, query: { p: p ? JSON.stringify(p) : undefined } })
}

export function navigateToFeedback(router: VueRouter, topic: string) {
  router.push({ name: feedBackRoute.name, query: { topic } })
}
